import { CxEvent } from '@spartacus/core';

export class FbqGgPostFormSuccessEvent extends CxEvent {
  event?: string;
}
